import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Hostel } from '@app/services/api/api.service';
import { LocaleService } from '@app/locale.service';

@Component({
  selector: 'app-hostel-description-mobile',
  templateUrl: './hostel-description-mobile.component.html',
  styleUrls: ['./hostel-description-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class HostelDescriptionMobileComponent {
  constructor(private localeService: LocaleService) {}

  @Output()
  cardClicked = new EventEmitter<void>();
  @Input()
  public hostel?: Hostel;

  public cardClick() {
    this.cardClicked.emit();
  }

  public getHostelDescription(): string {
    if (!this.hostel) {
      return '';
    }

    return this.hostel.descriptionTranslations
      ? this.hostel.descriptionTranslations[
          this.localeService.currentLocale.value
        ]
      : this.hostel.description;
  }
}
